<cs-header>
  <cs-header-title>{{ LL.mealPhotoScanner.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <!-- Dev-only (test mode) MOCK button: puts a fixed scan result on the page without calling the
       AI, so the result screen can be tried, and E2E-tested, with no camera and no AI call (#6807) -->
  @if (showMockButton && phase === 'camera' && !analyzing) {
    <div class="dev-mock-bar">
      <cs-button secondary small [label]="mockButtonLabel" (click)="mockAnalyzeAsync()"></cs-button>
    </div>
  }

  <!-- Camera Permission Denied: only while the camera is what the screen offers. On the results
       it is no help, and as a second card list above the results it left a wider gap (#6807) -->
  @if (cameraPermissionDismissed && phase === 'camera') {
    <cs-scanner-permission-denied [message]="LL.mealPhotoScanner.cameraPermissionDenied()" [scanner]="ScannerName.MealPhoto"></cs-scanner-permission-denied>
  }

  <!-- Phase 1: Camera -->
  @if (!cameraPermissionDismissed && phase === 'camera') {
    <cs-scanner-camera-stage #stage
      [photos]="capturedPhotos"
      [aspectRatio]="'4:3'"
      [bareCollage]="true"
      [analyzing]="analyzing"
      [progress]="analyzeProgress"
      [statusText]="LL.mealPhotoScanner.analyzing()"
      [suppressAnalyzingOverlay]="true"
      (cameraReady)="onCameraStateChange()"
      (cameraError)="onCameraError($event)"
      (permissionChange)="onCameraStateChange()">
    </cs-scanner-camera-stage>

    <!-- Bottom bar: the shutter while the camera runs; once a photo is captured
         the bar AREA stays reserved (so the photo keeps the camera's size) and
         holds the analyzing progress, instead of overlaying it on the image -->
    @if (stage.cameraView?.isActive && !analyzing) {
      <cs-scanner-shutter-bar [nativeShutterSound]="stage.cameraView?.isNative" (snap)="snapPhoto()">
        <div left class="left-buttons">
          <cs-button icon="add" secondary (click)="openFilePicker()"></cs-button>
          @if (modelSelection.scanMode === 'any') {
            <cs-scanner-model-picker
              [modelOptions]="modelSelection.modelOptions"
              [selectedModel]="modelSelection.selectedModel"
              (modelSelected)="onModelSelected($event)">
            </cs-scanner-model-picker>
          }
        </div>
      </cs-scanner-shutter-bar>
    } @else {
      <div class="scanner-bottom-bar">
        @if (analyzing) {
          <cs-scanner-analyzing-overlay
            [statusText]="LL.mealPhotoScanner.analyzing()"
            [progress]="analyzeProgress"
            [retryMessage]="retryMessage">
          </cs-scanner-analyzing-overlay>
        }
      </div>
    }
  }

  <!-- Phase 2: Results -->
  @if (phase === 'results') {
    <cs-card-list>
      @for (item of resultItems; track item.rowId) {
        <cs-food-card
          [food]="item.foodHeader"
          [nutrients]="item.nutrients"
          [description]="item.subtitle"
          [showMenuButton]="true"
          [menuIcon]="item.matched ? 'refresh' : 'search'"
          [menuLabel]="item.matched ? LL.mealPhotoScanner.changeButton() : LL.mealPhotoScanner.searchButton()"
          (menuClick)="item.matched ? replaceFood(item) : searchFood(item)"
          [checkable]="true"
          [checked]="item.checked"
          (checkedChange)="onItemToggled(item, $event)"
          (click)="onItemClick(item)">
        </cs-food-card>
      }
      <!-- a food on the plate the scan did not name (#6807) -->
      <!-- its own card: the list lays out every child as a card -->
      <cs-card class="add-missed-food">
        <cs-button secondary fit-width icon="add" [label]="LL.mealPhotoScanner.addFoodButton()" (click)="addMissedFood()"></cs-button>
      </cs-card>
    </cs-card-list>
  }
</cs-content>

<!-- Analyze + Retake buttons (after photo captured), stacked vertically -->
@if (phase === 'camera' && capturedPhoto && !analyzing) {
  <cs-page-action-buttons class="vertical">
    <cs-button primary [label]="LL.mealPhotoScanner.analyzeButton()" (click)="analyzePhoto()"></cs-button>
    <cs-button secondary [label]="LL.mealPhotoScanner.retakeButton()" (click)="retakePhoto()"></cs-button>
  </cs-page-action-buttons>
}

<!-- Add to Meal + Retake buttons, stacked vertically -->
@if (phase === 'results') {
  <cs-page-action-buttons class="vertical">
    <cs-button primary
      [label]="actionButtonLabel"
      [disabled]="checkedCount === 0"
      (click)="addToMeal()">
    </cs-button>
    <cs-button secondary [label]="LL.mealPhotoScanner.retakeButton()" (click)="retakeFromResults()"></cs-button>
  </cs-page-action-buttons>
}
